import * as React from 'react';
import { FormInput } from './FormInput';

interface IFormInputPasswordProps {
	onChange?: (e: any) => any;
	name: string;
	id: string;
	allowToggleVisibility?: boolean;
	required: boolean;
	defaultValue?: string;
}

interface IPasswordState {
	allowToggleVisibility: boolean;
	hiddenPassword: boolean;
}

export class FormInputPassword extends React.Component<IFormInputPasswordProps, IPasswordState> {

	constructor(props: IFormInputPasswordProps) {
		super(props);
		this.state = {
			allowToggleVisibility: this.props.allowToggleVisibility,
			hiddenPassword: true,
		} as IPasswordState;
	}

	public componentWillMount() {
		const state = this.state || {} as IPasswordState;

		if (state.allowToggleVisibility === undefined) {
			this.setState({ allowToggleVisibility: true });
		}
	}

	public render() {
		const state = this.state || {} as IPasswordState;
		const props = this.props || {} as IFormInputPasswordProps;

		const classList = ['form__input__password'];
		if (state.allowToggleVisibility) {
			classList.push('form__input__password--labelled');
		}

		const togglePasswordVisibility = () => {
			this.setState({ hiddenPassword: state.hiddenPassword ? false : true });
		};

		return <div className={classList.join(' ')}>
			<div>
				<FormInput
					onChange={props.onChange}
					type={state.hiddenPassword ? 'password' : 'input'}
					required
					name={props.name}
					id={props.id}
					autoComplete="off" />
			</div>
			{state.allowToggleVisibility ? <a href="#"
				id={props.id}
				onClick={(e) => {
					e.preventDefault();
					togglePasswordVisibility();
				}}
			>
				{state.hiddenPassword ? 'Show' : 'Hide'}
			</a>
				: null}
		</div>;
	}
}
